/**
 * Tracks the last hovered tree node and the last hovered id set so a
 * renderer can skip re-rendering when a pointer move changes nothing.
 */
export class HoverTracker {
  private lastNodeId: string | null = null;
  private lastIdsKey = '';

  /** Records the hovered node and returns true when it differs from the previous one. */
  nodeChanged(nodeId: string | null): boolean {
    if (nodeId === this.lastNodeId) return false;
    this.lastNodeId = nodeId;
    return true;
  }

  /** Records the hovered id set and returns true when it differs from the previous set. */
  hoveredIdsChanged(ids: string[]): boolean {
    const key = [...ids].sort().join('\u0000');
    if (key === this.lastIdsKey) return false;
    this.lastIdsKey = key;
    return true;
  }
}
